import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInfoLabels from "../customInfoLabels";
import {primaryColor} from "../../material-dashboard-pro-react";
import estadoPillStyle from "assets/jss/material-dashboard-pro-react/estadoPillStyle.jsx";

const filtrosAcontecimentoStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  tooltip,
  ...customInfoLabels,
  ...buttonStyle,
  ...customSelectStyle,
  ...estadoPillStyle,
  subComponent: {
    padding: 20,
    backgroundColor: "#edf8fb",
    boxShadow: "inset 0px 35px 10px -30px rgba(0,0,0,0.05), inset 0px -35px 10px -30px rgba(0,0,0,0.05)",

    "& label": {
      color: "#000000",
      fontWeight: "inherit",
    },

    "& p": {
      margin: 0
    },

    "& pre": {
      fontSize: "0.8em"
    }
  },
  resumo: {
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    }
  },
  acoes: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  dropzoneRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "25px",
    background: "#f6f9f7"
  },
  downloadExemplo: {
    float: "right",
    cursor: "pointer",

    "& small:hover": {
      color: primaryColor
    }
  },
  filtros: {
    background: "#F4F4F4",
    padding: "10px",
    fontSize: "0.8em",
    marginTop: "-7.5px"
  },
  percursoBadge: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: 4,
    fontSize: "0.85em",
    fontWeight: 500,
    color: "#fff",
    whiteSpace: "nowrap"
  },
  percursoBadgePE: {
    backgroundColor: "#4fa7bb"
  },
  percursoBadgePGL: {
    backgroundColor: "#d87d32"
  }
};

export default filtrosAcontecimentoStyle;
